import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationScenarioComparisonBwIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M136 136V888H888V136H136ZM96 64C78.3269 64 64 78.3269 64 96V928C64 945.673 78.3269 960 96 960H928C945.673 960 960 945.673 960 928V96C960 78.3269 945.673 64 928 64H96Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M236 204C218.327 204 204 218.327 204 236V576C204 593.673 218.327 608 236 608H415V416H608V236C608 218.327 593.673 204 576 204H236Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M416 608V788C416 805.673 430.327 820 448 820H788C805.673 820 820 805.673 820 788V448C820 430.327 805.673 416 788 416H608V608H416Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  )
] });
export {
  VisualisationScenarioComparisonBwIcon
};
